<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-card>
      <v-card-text class="pa-5">
        <v-row justify="space-between">
          <v-col cols="12" lg="4">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Поиск..."
              filled
              background-color="transparent"
              hide-details
              name="title"
            >
              <v-btn v-if="search" class="reset-button"
                     slot="append"
                     icon
                     @click="search = null"
                     color="red"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-text-field>
          </v-col>
          <v-col cols="12" lg="4" class="justify-end align-center d-flex">
            <v-dialog v-model="dialog" persistent max-width="700px">
              <template v-slot:activator="{ on }">
              </template>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :options.sync="options"
              :server-items-length="total"
              :search="search"
            >
              <template v-slot:item.answer="{ item }">                               
                <v-chip v-if="item.answer.length > 0">Есть ответ</v-chip>
              </template>
              <template v-slot:item.actions="{item}">
                <v-btn
                  :href="editItem(item)"
                  icon
                  small
                >
                  <v-icon color="primary">
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-icon
                  color="red"
                  @click="deleteItem(item)"
                  small
                >
                  mdi-delete
                </v-icon>
              </template> 
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {QuestionsAnswers} from '../../../models/answer';
import axiosInstance from "../../../axiosInstance";

export default {
  name: 'Index',
  data: () => ({
    search: '',
    loading: true,
    total: 0,
    options: {
      sortBy: ['created_at'],
      sortDesc: [true],
    },
    filters: {
      type: null,
      status: null,
    },
    headers: [
      {text: 'Id', value: 'id'},
      {text: 'Вопрос', value: 'question'},
      {text: 'Ответ', value: 'answer'},
      {text: 'Дата создания', value: 'created_at'},
      {text: 'Дата обновления', value: 'updated_at'},
      {text: 'Дата ', value: 'actions'},
    ],
    items: [],
    page: {
      title: "Ответы на вопросы"
    },
    breadcrumbs: [
      {
        text: "Админ панель",
        disabled: false,
        to: '/'
      },
      {
        text: "Ответы на вопросы",
        disabled: true,
        to: '/answers'
      },
    ],
  }),
  created() {
    this.get();
  },
  computed: {

  },
  methods: {
    editItem(item) {
      return this.$router.resolve({name: 'answers-edit', params: {id: item.id}}).href
    },
    async deleteItem(item) {
      await QuestionsAnswers.$query().destroy(item.id);
      await this.get();
    },
    async get() {
      this.loading = true;
      const {sortBy, sortDesc, page, itemsPerPage} = this.options;
      const {type, status} = this.filters;
      let data = {filters: []};
      this.search ? data.search = {value: this.search} : null;
      sortBy && sortBy[0] ? data.sort = [{field: sortBy[0], direction: sortDesc[0] ? 'desc' : 'asc'}] : null;

      type !== null ? data.filters.push({field: 'type', operator: '=', value: type}) : null;
      status !== null ? data.filters.push({field: 'status', operator: '=', value: status}) : null;


      await axiosInstance.post(`/answers/search?limit=${itemsPerPage}&page=${page}`, data).then((response) => {
        this.items = response.data.data;
        this.total = response.data.meta.total;
      })
      this.loading = false;
    },
  },
  watch: {
    options: {
      handler() {
        this.get()
      },
      deep: true,
    },
    search: {
      handler() {
        this.get();
      }
    },
    filters: {
      handler() {
        this.get();
      },
      deep: true,
    }
  }
};
</script>
